import firebase from '../../api/firebase';
const db = firebase.firestore();

const state = () => ({
  category: localStorage.getItem('category') || 'dev',
  topicsList: {},
  currentTopic: JSON.parse(localStorage.getItem('currentTopic')) || {
    displayName: '.NET Core',
    topicName: 'netCore',
  },
  questions: {},
  sortDifficulty: [],
  sortQuery: '',
  sortType: false,
  completedList: [],
  isLoading: false,
});

const getters = {
  getCategory: (state) => state.category,
  getTopicsList: (state) => state.topicsList[state.category],
  getCurrentTopic: (state) => state.currentTopic,
  getQuestions: (state) => state.questions[state.currentTopic.topicName],
  getSortDifficulty: (state) => state.sortDifficulty,
  getSortQuery: (state) => state.sortQuery,
  getSortType: (state) => state.sortType,
  getCompletedList: (state) => state.completedList,
  getIsLoading: (state) => state.isLoading,
};

const mutations = {
  setCategory: (state, category) => {
    state.category = category;
  },
  setTopicsList: (state, topicsList) => {
    state.topicsList = { ...state.topicsList, [state.category]: topicsList };
  },
  setCurrentTopic: (state, topic) => {
    state.currentTopic = topic;
  },
  setQuestions: (state, questionsList) => {
    state.questions = {
      ...state.questions,
      [state.currentTopic.topicName]: questionsList,
    };
  },
  setSortDifficulty: (state, sortDifficulty) => {
    state.sortDifficulty = sortDifficulty;
  },
  setSortQuery: (state, sortQuery) => {
    state.sortQuery = sortQuery;
  },
  setSortType: (state, sortType) => {
    state.sortType = sortType;
  },
  setCompletedList: (state, completedList) => {
    state.completedList = completedList;
  },
};

const actions = {
  updateCategory({ commit, dispatch }, category) {
    localStorage.setItem('category', category);

    commit('setCategory', category);
    dispatch('fetchTopics');
  },
  updateCurrentTopic({ commit, dispatch }, topic) {
    const currentTopic = JSON.stringify(topic);
    localStorage.setItem('currentTopic', currentTopic);

    commit('setCurrentTopic', topic);
    commit('setSortDifficulty', []);
    commit('setSortQuery', '');
    commit('setSortType', false);
    dispatch('fetchQuestions');
  },
  updateSortDifficulty({ commit }, sortDifficulty) {
    commit('setSortDifficulty', sortDifficulty);
  },
  updateSortQuery({ commit }, sortQuery) {
    commit('setSortQuery', sortQuery);
  },
  updateSortType({ commit }, sortType) {
    commit('setSortType', sortType);
  },
  createCompletedList({ commit, state }) {
    const completedList = JSON.parse(
      localStorage.getItem(`${state.currentTopic.topicName}Completed`)
    );

    if (completedList) {
      commit('setCompletedList', completedList);
    } else {
      localStorage.setItem(
        `${state.currentTopic.topicName}Completed`,
        JSON.stringify([])
      );
    }
  },
  updateCompletedList({ commit, state }, uid) {
    if (state.completedList.length === 0) {
      localStorage.setItem(
        `${state.currentTopic.topicName}Completed`,
        JSON.stringify([uid])
      );
      commit('setCompletedList', [uid]);
      return;
    }

    const index = state.completedList.find((item) => item === uid);
    if (index) {
      const filtered = state.completedList.filter((item) => item !== index);
      localStorage.setItem(
        `${state.currentTopic.topicName}Completed`,
        JSON.stringify(filtered)
      );
      commit('setCompletedList', filtered);
    } else {
      localStorage.setItem(
        `${state.currentTopic.topicName}Completed`,
        JSON.stringify([...state.completedList, uid])
      );

      const newList = [...state.completedList, uid];
      commit('setCompletedList', newList);
    }
  },
  async fetchTopics({ commit, state }) {
    if (state.topicsList[state.category]) return;

    const categoryRef = db.collection('categories').doc(`${state.category}`);
    const topicsDocs = await categoryRef.get('topicsList');
    const { topicsList } = topicsDocs.data();
    commit('setTopicsList', topicsList);
  },
  async fetchQuestions({ commit, state }) {
    if (state.questions[state.currentTopic.topicName]) return;

    const questionsRef = db
      .collection('questions')
      .doc(`${state.currentTopic.topicName}Questions`)
      .collection(`${state.currentTopic.topicName}Questions`)
      .orderBy('difficulty', 'asc');
    const questionsDocs = await questionsRef.get();
    const questionsList = [];
    questionsDocs.forEach((doc) =>
      questionsList.push({ ...doc.data(), uid: doc.id })
    );
    commit('setQuestions', questionsList);
  },
  async fetchAnswer({ state }, uid) {
    const answerRef = db
      .collection('answers')
      .doc(`${state.currentTopic.topicName}Answers`)
      .collection(`${state.currentTopic.topicName}Answers`)
      .doc(uid);

    const answerRequest = await answerRef.get();
    const answer = await answerRequest.data();
    return answer;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
